import { Box } from '@mui/material';
import { useAtom } from 'jotai';
import { useCallback } from 'react';

import ContentNotification from '@/components/ContentNotfication';
import AdminDevicesTable from '@/features/DevicesTable/AdminDevicesTable';
import LogSourcesCreateDialog from '@/features/LogSourcesCreate/LogSourcesCreateDialog';
import { selectedOrganizationIdAtom } from '@/pages/Organizations';

import useFetchEnvironment from '../Administration.hooks';
import DeviceDetails from './DeviceDetails';
import useDeviceQueryParam, { useDeviceSelectionParams } from './Devices.hooks';
import useStyles from './Devices.styles';

const Devices = () => {
  const [selectedOrganizationId] = useAtom(selectedOrganizationIdAtom);
  const { removeFilter } = useDeviceQueryParam();
  const { hasDetailSelection } = useDeviceSelectionParams();
  //-----------------------------------------------------------------
  useFetchEnvironment();
  const closeDeviceDetail = useCallback(() => {
    removeFilter();
  }, [removeFilter]);

  const { classes } = useStyles({
    deviceDetailsCollapsed: !hasDetailSelection
  });

  return (
    <>
      {selectedOrganizationId === 0 && (
        <ContentNotification
          title="Select an organization"
          text="Please select an organization to view and edit its devices."
        />
      )}
      {selectedOrganizationId !== 0 && (
        <Box className={classes.devicesPage}>
          <Box className={classes.devicesPageContent}>
            <AdminDevicesTable
              closeDeviceDetail={closeDeviceDetail}
              isMainDevicePage={false}
            />
            {hasDetailSelection && (
              <DeviceDetails
                closeDeviceDetail={closeDeviceDetail}
                isMainDevicePage={false}
              />
            )}
          </Box>
        </Box>
      )}
      <LogSourcesCreateDialog />
    </>
  );
};

export default Devices;
